"use strict";

var _StandaloneMsgHandler = require("../../eventbus/StandaloneMsgHandler");
var _usersmanagement = require("../../functions/usersmanagement");
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/usd/clearancedata", function (method, data) {
  if (method === "get") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.getClearances)())
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/usd/clearanceaction", function (method, data) {
  if (method === "get") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.getClearanceActions)())
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/usd/clearancelevel", function (method, data) {
  if (method === "get") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.getClearanceLevels)())
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/usd/filteredclearancelevel", function (method, data) {
  if (method === "get") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.getClearanceLevels)())
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/usd/clearancedata/add", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.addLevel)(data))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/usd/clearancedata/update", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.editLevel)(data))
    };
  }
});
(0, _StandaloneMsgHandler.registerStandaloneAPIHandler)("/aether/auth/kc/usd/clearancedata/delete", function (method, data) {
  if (method === "post") {
    return {
      response: (0, _StandaloneMsgHandler.createUIReply)((0, _usersmanagement.deleteLevel)(data))
    };
  }
});